module.exports = __webpack_public_path__ + "static/00016.39e58c7c.jpg";